// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__25Klj","list":"BalanceDue_list__3gjFP","listRow":"BalanceDue_listRow__3ReBD","total":"BalanceDue_total__2SDsL"};